module.exports = __webpack_public_path__ + "media/images/icons/filled/shopping-7c663303127b1902b94eac85f4fe11bd.svg";